package one.primehealth.analytics.impl

import one.healthium.domain.user.UserModel
import one.healthium.domain.user.models.Gender
import one.healthium.domain.user.models.UserProfileModel

internal class HltmUserMapper {

    fun map(user: UserModel): Map<String, Any?> {
        return buildMap {
            putAll(user.profile.toAnalyticsMap())
            user.id.takeUnless { user.isLocalId }?.let { put("user_id", it) }
        }
    }

    private fun UserProfileModel.toAnalyticsMap(): Map<String, Any?> {
        return buildMap {
            name?.let { put("name", it) }
            age?.let { put("age", it) }
            weight?.let { put("weight", it) }
            targetWeight?.let { put("target_weight", it) }
            height?.let { put("height", it) }
            gender?.let { put("gender", it.toAnalyticsValue()) }
            email?.let { put("email", it) }
            if (additionalInfo.isNotEmpty()) {
                put(
                    "additional_info",
                    additionalInfo.mapKeys { (key, _) -> normalizeKey(key) }
                        .mapValues { (_, values) ->
                            values.map { value -> value.key }
                        }
                )
            }
            if (additionalText.isNotEmpty()) {
                put(
                    "additional_text",
                    additionalText.mapKeys { (key, _) -> normalizeKey(key) }
                )
            }
            if (statements.isNotEmpty()) {
                put(
                    "statements",
                    statements.mapKeys { (key, _) -> normalizeKey(key) }
                )
            }
        }
    }

    private fun Gender.toAnalyticsValue(): String {
        return name.lowercase()
    }

    private fun normalizeKey(key: String): String {
        return key.trim().lowercase().replace(" ", "_")
    }
}
